export function privacy() {
    if (window.matchMedia("(max-width: 700px)").matches) {
        window.open('/datenschutz.html', '_blank');
        return;
    }

    if ($jq3(".privacy-overlay").length) {
        $jq3(".privacy-overlay").addClass("privacy-overlay--is-active");
    } else {
        $jq3('.main').append('<div class="privacy-overlay"></div>');

        $jq3('.privacy-overlay').load('/snippets/datenschutzpopup', function () {
            $jq3('.privacy-overlay__closer').on('click', function (e) {
                e.preventDefault();
                $jq3(".privacy-overlay").removeClass("privacy-overlay--is-active");
            });

            privacy();
        })
    }
}